import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style';
import { MainButton } from '../buttons/MainButton';

const styles = StyleSheet.create({
  accountQuestion: {
    marginTop: 20,
    fontSize: theme.FONT_SIZE_SMALL,
  },
  dataLink: {
    color: theme.GREEN_WARM_COLOR,
    fontSize: theme.FONT_SIZE_SMALL,
    textDecorationLine: 'underline',
  },
});

const AuthFooter = ({ question, linkTitle, onClick, navigateToDataDeclaration }) => (
  <>
    <CustomText style={styles.accountQuestion}>{question}</CustomText>
    <MainButton
      btnMarginTop={5}
      btnMarginBottom={20}
      title={linkTitle}
      textColor={theme.WHITE_COLOR}
      btnBgColor={theme.GREEN_WARM_COLOR}
      btnWidth={120}
      btnPadding="5%"
      btnPress={onClick}
    />
    <TouchableOpacity onPress={navigateToDataDeclaration}>
      <CustomText style={[styles.dataLink]}>Data Policy</CustomText>
    </TouchableOpacity>
  </>
);

export default AuthFooter;
